import { useState } from "react";
import { useParams } from "react-router-dom";
import { useFindAllTargetListQuery } from "../../../../../features/targetlistApi";
import { Preferences } from "../../../../lib/preferences";
import { PreferencesSection } from "../../../../lib/preferences/dto";
import { Spinner } from "../../../../ui/molecules/spinner";
import { NotFound } from "../../../../ui/organisms/notFound";
import { FindAllTargetListsFilters } from "../../../targetList/dto";
import { TargetListsFilters } from "../../../targetList/list/filters";
import { TargetListsList } from "../../../targetList/list/list";

export function TargetLists() {
  const { projectId } = useParams()

  const [filters, setFilters] = useState<FindAllTargetListsFilters>({
    commercial: [],
    contacts: "",
    itemsPerPage: 50,
    name: "",
    order: true,
    page: 0,
    sort: "name",
    state: [],
    teamLeader: [],
    project: [projectId || ""],
    sector: [],
    category: []
  });
  const { data, isLoading } = useFindAllTargetListQuery(filters, {
    skip: projectId === undefined
  });

  const targetLists = data?.targetLists;
  const commercials = data?.commercials;
  const teamLeaders = data?.teamLeaders;

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen w-full"><Spinner /></div>
  }

  return (
    <div className="p-4 h-full max-h-full">
      <div className="flex flex-col bg-white h-full max-h-full rounded-2xl shadow-sm">
        {isLoading ? (
          <div className="w-full h-[50%] flex items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <div style={{ height: 'calc(100%)' }}>
            <TargetListsFilters filters={filters} setFilters={(f) => setFilters({ ...filters, ...f, page: 0 })} />
            {targetLists === undefined ||
              !targetLists?.data ||
              targetLists.total === 0 ||
              targetLists?.data?.length === 0 ? (
              <div style={{ height: 'calc(100% - 64px)' }}>
                <NotFound />
              </div>
            ) : (
              <TargetListsList
                isFromProject
                commercials={commercials!}
                teamLeaders={teamLeaders!}
                filters={filters}
                targetLists={targetLists!}
                setFilters={(f) => setFilters({ ...filters, ...f, page: 0 })}
                setItemsPerPage={(itemsPerPage) => setFilters({ ...filters, itemsPerPage, page: 0 })}
                setPage={(page) => setFilters({ ...filters, page })}
              />
            )}
          </div>
        )}
        <Preferences section={PreferencesSection.targetListPreferences} key={PreferencesSection.targetListPreferences} />
      </div>
    </div>
  );
}
